module.exports = __webpack_public_path__ + "static/media/promo.16a23831.mp4";